<template>
  <div class="content-pool-container">
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box flex-3">
          <div class="search-wrap">
            <div class="control">
              <label class="label inline-block r-top">来源</label>
              <span class="inline-block width-4">
                <el-select v-model="search.sourceType" filterable placeholder="请选择" @change="updateSourceTypeOpt">
                  <el-option
                    v-for="item in allOpts.sourceTypeList"
                    :key="item.type"
                    :label="item.name"
                    :value="item.type">
                  </el-option>
                </el-select>
              </span>
            </div>
            <div class="control">
              <label class="label inline-block r-top">账号</label>
              <span class="inline-block width-4">
                <el-select v-model="search.accountId" filterable placeholder="请选择">
                  <el-option
                    v-for="item in allOpts.sourceList"
                    :key="item.accountId"
                    :label="item.accountName"
                    :value="item.accountId">
                  </el-option>
                </el-select>
              </span>
            </div>
            <div class="control">
              <label class="label inline-block r-top">类型</label>
              <span class="select">
                <select v-model="search.articleType">
                  <option value="-1">全部</option>
                  <option :value="opt.type" v-for="opt in allOpts.articleTypes">{{opt.name}}</option>
                </select>
              </span>
            </div>
            <div class="control">
              <label class="label inline-block r-top">关键词</label>
              <input type="text" class="input width-2" v-model="search.keyword">
            </div>
            <div class="control">
              <label class="label inline-block r-top">feedId</label>
              <input type="text" class="input width-3" v-model="search.feedId">
            </div>
            <div class="control">
              <label class="label inline-block r-top">ICON标签</label>
              <span class="inline-block width-4">
              <el-select v-model="search.iconTags" filterable multiple placeholder="请选择">
                <el-option
                  v-for="item in allOpts.iconTags"
                  :key="item.tagId"
                  :label="item.name"
                  :value="item.tagId">
                </el-option>
              </el-select>
                <!-- <v-select :options="allOpts.iconTags" :show-labels=false label="name" :multiple="true"
                          key="name" @update="updateIconTagsOpt" placeholder="请选择"></v-select> -->
              </span>
            </div>
            <div class="control">
              <label class="label inline-block r-top">来源发帖时间</label>
              <el-date-picker
                v-model="search.publishTimeStart"
                type="datetime"
                placeholder="选择开始时间">
              </el-date-picker>
              <span>~</span>
              <el-date-picker
                v-model="search.publishTimeEnd"
                type="datetime"
                placeholder="选择结束时间">
              </el-date-picker>
            </div>
            <div class="control">
              <button class="button is-info" @click="doSearch">搜索</button>
            </div>
          </div>
        </article>
        <div class="flex-space"></div>
        <article class="tile is-child box flex-1" >
          <label class="title">数据</label>
          <div class="data-wrap">
            <div class="data-item">
              <label class="label">总爬取数</label>
              <label class="label">{{stats.totalCount}}</label>
            </div>
            <div class="data-item">
              <label class="label">当日爬取数</label>
              <label class="label">{{stats.concreteTotalCount}}</label>
            </div>
            <div class="data-item">
              <label class="label">总已识图数</label>
              <label class="label">{{stats.detectCount}}</label>
            </div>
            <div class="data-item">
              <label class="label">当日已识图数</label>
              <label class="label">{{stats.concreteDetectCount}}</label>
            </div>
            <div class="data-item">
              <label class="label">总内容池feed数</label>
              <label class="label">{{stats.contentCount}}</label>
            </div>
            <div class="data-item">
              <label class="label">当日内容池feed总数</label>
              <label class="label">{{stats.concreteContentCount}}</label>
            </div>
          </div>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="content-list" v-if="count > 0">
        <waterfall>
          <div class="waterfall-container">
            <content-card class="waterfall-item" v-for="item in list" :key='item.feedId' :icon-tags-all-list="allOpts.iconTags" :source="item" :data-feed-id="item.feedId"></content-card>
          </div>
        </waterfall>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  import contentCard from './contentCard.vue'
  import waterfall from 'COMMON/waterfall/waterfall.vue'
  import {mapActions} from 'vuex';
  import {getTimeByDateStr} from 'UTILS/date'

  export default {
    components: {
      contentCard,waterfall
    },
    data(){
      return {
        count:0,
        list:[],
        search:{
          sourceType:-1,
          accountId:-1,
          articleType:-1,
          keyword:'',
          iconTags:[],
          publishTimeStart:'',
          publishTimeEnd:'',
          page:1,
          pageSize:15,
          feedId:"",
        },
        allOpts:{
          sourceTypeList:[],
          sourceList:[{accountId:-1,accountName:"全部"}],
          articleTypes:[],
          iconTags:[]
        },
        stats:{}
      }
    },
    created(){
      this.getList()
      this.getAllOptions()
      this.search.feedId = this.$route.query.searchFeedId;
    },
    methods: {
      ...mapActions([
        'commitWaterfallUpdate'
      ]),
      /**
       * 接收子组件pagination分页点击事件
       * @param  {[type]} value [description]
       * @return {[type]}       [description]
       */
      handleCurrentChange(value) {
        if(this.search.page !== value){
          this.search.page = value;
           this.getList();
        }
      },
      getList(){
        let params = Object.assign({},this.search);
        if (params.publishTimeStart && params.publishTimeEnd && params.publishTimeStart > params.publishTimeEnd) {
          this.$message("开始时间必须小于结束时间")
        }
        params.publishTimeStart = getTimeByDateStr(params.publishTimeStart)
        params.publishTimeEnd = getTimeByDateStr(params.publishTimeEnd)
        HttpRequest.get('/admin.php?method=fashion.getContentPoolList',params).then(response => {
          this.count = 0;
          setTimeout(()=>{//该出为触发瀑布流渲染的hack处理
            this.count = response.data.count;
            this.list = _.toArray(response.data.list);
            this.commitWaterfallUpdate(true);
            this.stats = response.data.stats
          },0)
        })
      },
      doSearch(){
        this.search.page = 1
        this.getList()
      },
      /**
       * 获取数据Options
       */
      getAllOptions(){
        HttpRequest.get("/admin.php?method=blogger.getTags").then(response => {
          this.allOpts.articleTypes = _.toArray(response.data.articleTypes)
          this.allOpts.iconTags = _.toArray(response.data.iconTags)
        })
        HttpRequest.get("/admin.php?method=fashion.getSourceTypeList").then(response => {
          this.allOpts.sourceTypeList = _.toArray(response.data)
          this.allOpts.sourceTypeList.unshift({
            type:-1,
            name:"全部"
          })
        })
      },
      updateSourceTypeOpt(obj){
        if(!obj){
          this.search.sourceType = -1;
          return false
        }
        this.search.sourceType = obj
        if(this.search.sourceType === -1){
          this.allOpts.sourceList = []
          return false
        }
        HttpRequest.get("/admin.php?method=blogger.getAllSourceByType",{type:obj}).then(response => {
          this.allOpts.sourceList = _.toArray(response.data.list);
          this.allOpts.sourceList.unshift({
            accountId:-1,
            accountName:"全部"
          })
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .content-pool-container {
    .list-wrap {
      .is-parent {
        .flex-1 {
          flex-grow: 1;
        }
        .flex-3 {
          flex-grow: 3;
        }
        .flex-space {
          flex-basis: 20px;
        }
      }
      .is-child {
        .data-wrap {
          display: flex;
          flex-wrap: wrap;
          width: 400px;
          .data-item {
            width:50%;
            margin-top: 20px;
          }
        }
      }
      .content-list {
        padding: 10px;
      }
    }
  }
</style>
